import React, { Fragment, useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { Button, CircularProgress, IconButton } from "@mui/material";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Cancel,
  Delete,
  Category,
  DeleteForever,
} from "@mui/icons-material";

import PopUpModel from "components/Popup/PopUpModel";
import TemporaryDrawer from "components/TemporaryDrawer";
import SkeletonLoader from "components/Loader/SkeletonLoader";
import NotFoundComponent from "components/NotFoundComponent";
import noFoundImg from "../../assets/img/no-data-found.jpg";
import { DeskTopContainer } from "themes/Device";
import { MobileContainer } from "themes/Device";
import MobileTitle from "components/MobileTitle";
import SearchBarInput from "components/SearchBarInput";
import MobileCategory from "components/MobileCategory";
import { RESOURCE } from "common/constant";
import { ACTION } from "common/constant";
import RoleBasedGuard from "guards/RoleBasedGuard";
//context
import {
  useLayoutState,
  useLayoutDispatch,
  addCurrentScreenTitle,
} from "context/LayoutContext";
import AddEditCoupons from "./AddEditCoupons";
import {
  useDeleteCouponsMutation,
  useCoupons,
  useBulkDeleteCouponsClassMutation
} from "hooks/react-query/useCoupons";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Label from "components/Label";
import moment from "moment";
import CheckPermission from "guards/CheckPermission";

const PREFIX = 'CouponsList';

const classes = {
  cardCategoryWhite: `${PREFIX}-cardCategoryWhite`,
  cardTitleWhite: `${PREFIX}-cardTitleWhite`,
  root: `${PREFIX}-root`,
  tabel: `${PREFIX}-tabel`,
  prioritybtn: `${PREFIX}-prioritybtn`,
  mobileCard: `${PREFIX}-mobileCard`,
  mobileCategoryCard: `${PREFIX}-mobileCategoryCard`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.cardCategoryWhite}`]: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },

  [`& .${classes.cardTitleWhite}`]: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontFamily: '"Oxygen", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },

  [`& .${classes.root}`]: {
    width: "100%",
  },

  [`& .${classes.tabel}`]: {
    margin: "10px",
    marginTop: "0",
    "& .MuiPaper-root": {
      padding: 10,
      paddingBottom: 0
    },
    "& tr": {
      height: 50,
      "& .MuiTableCell-root": {
        paddingLeft: "15px",
        fontSize: "14px !important",
      },
    },
  },

  [`& .${classes.prioritybtn}`]: {
    "& a:hover,& a:focus": {
      backgroundColor: "#FF5C93",
    },
    marginLeft: "5px",
    backgroundColor: "#FF5C93",
    color: "white",
  },

  [`& .${classes.mobileCard}`]: {
    padding: "2px",
    paddingBottom: '80px'
  },

  [`& .${classes.mobileCategoryCard}`]: {
    margin: '0 auto'
  }
}));

const CouponsList = () => {
  const theme = useTheme();

  const { data: expenseCategoryDataList, loading: expenseCategoryLoader } =
    useCoupons();
  const { mutate: deleteCoupons } = useDeleteCouponsMutation();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteCouponsId, setDeleteCouponsId] = useState(0);
  const [deletingBtnProcess, setDeletingBtnProcess] = useState(false);
  const [addEditDrawerShow, setAddEditDrawerShow] = useState(false);
  const [addEditCouponsId, setAddEditCouponsId] = useState(0);
  const [searchCoupons, setSearchCoupons] = useState("");
  const [filterCouponsList, setFilterCouponsList] = useState(
    [],
  );

  const history = useHistory();
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (layoutState?.currentScreenTitle !== "Coupon") {
      addCurrentScreenTitle(layoutDispatch, {
        currentScreenTitle: "Coupon",
      });
    }
    return () => {
      if (layoutState?.currentScreenTitle === "Coupon") {
        addCurrentScreenTitle(layoutDispatch, { currentScreenTitle: "" });
      }
    };
  }, []);

  const deleteFoodCategoryData = (couponId) => {
    if (couponId > 0) {
      setDeletingBtnProcess(true);
      deleteCoupons(couponId);
      setDeletingBtnProcess(false);
      setDeleteModalShow(false);
    }
  };

  const addEditDrawerClose = () => {
    setAddEditDrawerShow(false);
    setAddEditCouponsId(0);
  };

  const deleteData = (deleteid) => {
    setDeleteCouponsId(deleteid);
    setDeleteModalShow(true);
  };
  const editData = (editid) => {
    history.push({
      pathname: `/app/coupons/edit/${editid}`,
      state: {
        couponId: editid,
        backToMain: () => history.push(`/app/coupons`),
      },
    });
  };
  const addDrawerShow = () => {
    history.push({
      pathname: `/app/coupons/add`,
      state: {
        couponId: 0,
        backToMain: () => history.push(`/app/coupons`),
      },
    });
  };

  const clearTxt = () => {
    setSearchCoupons("");
  };

  useEffect(() => {
    setFilterCouponsList(expenseCategoryDataList);
  }, [expenseCategoryDataList]);

  useEffect(() => {
    if (searchCoupons) {
      let filterCategoryList = expenseCategoryDataList?.filter(
        (item) =>
          item.code &&
          item.code
            ?.toLowerCase()
            ?.includes(searchCoupons.toLowerCase()),
      );
      setFilterCouponsList(filterCategoryList);
    } else {
      setFilterCouponsList(expenseCategoryDataList);
    }
  }, [searchCoupons]);

  const { mutate: deleteBulkCoupons } = useBulkDeleteCouponsClassMutation();
  const [bulkDeleteIds, setbulkDeleteIds] = useState([]);
  const [deletebulkPopupshow, setDeletebulkPopupshow] = useState(false);
  const handleDeleteRows = async () => {
    setDeletebulkPopupshow(false)
    setbulkDeleteIds([]);
    deleteBulkCoupons({
      variables: {
        input: {
          ids: bulkDeleteIds
        },
      },
    });
  };
  const handleDeleteRowsConformation = async (event, rowData) => {
    const ids = rowData.map((d) => d.id);
    setDeletebulkPopupshow(true)
    setbulkDeleteIds(ids);
  };
  return (
    <Root>
      <DeskTopContainer>
        <div className={classes.tabel}>
          <MaterialTable
            title={
              <h5>
                <b className="ml-3">{"Coupon"}</b>
              </h5>
            }
            columns={[
              {
                title: "Coupon Code",
                field: "code",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Description",
                field: "description",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Active",
                field: "active",
                cellStyle: {
                  width: "10%",
                },
              },
              {
                title: "Type",
                field: "type",
                cellStyle: {
                  width: "10%",
                },
              },
              {
                title: "Amount",
                field: "amount",
                cellStyle: {
                  width: "10%",
                },
              },
              {
                title: "Active From",
                field: "active_from",
                cellStyle: {
                  width: "10%",
                },
                render: (rowData) =>
                  rowData?.active_from &&
                  moment(rowData?.active_from).format("DD/MM/YYYY"),
              },
              {
                title: "Expire At",
                field: "expire_at",
                cellStyle: {
                  width: "10%",
                },
                render: (rowData) =>
                  rowData?.expire_at &&
                  moment(rowData?.expire_at).format("DD/MM/YYYY"),
              },
              {
                title: "Priority",
                field: "priority",
                cellStyle: {
                  width: "10%",
                },
              },
              {
                title: "Action",
                field: "action",
                cellStyle: {
                  width: "10%",
                },
                render: (rowData) => (
                  <Fragment>
                    <RoleBasedGuard
                      resource={RESOURCE.COUPONS}
                      action={ACTION.UPDATE}
                    >
                      <IconButton
                        color="primary"
                        title={"Edit Coupon"}
                        aria-label={"Edit Coupon"}
                        onClick={() => {
                          setAddEditCouponsId(rowData.id);
                          setAddEditDrawerShow(true);
                        }}
                        size="large">
                        <EditIcon />
                      </IconButton>
                    </RoleBasedGuard>
                    <RoleBasedGuard
                      resource={RESOURCE.COUPONS}
                      action={ACTION.DELETE}
                    >
                      <IconButton
                        color="secondary"
                        title={"Delete Coupon"}
                        aria-label={"Delete Coupon"}
                        onClick={() => {
                          setDeleteCouponsId(rowData.id);
                          setDeleteModalShow(true);
                        }}
                        size="large">
                        <DeleteIcon />
                      </IconButton>
                    </RoleBasedGuard>
                  </Fragment>
                ),
              },
            ]}
            data={expenseCategoryDataList?.map((item, index) => {
              return {
                code: item.code,
                description: item.description,
                type: item.type,
                amount: item.amount,
                active_from: item.active_from,
                expire_at: item.expire_at,
                maximumDiscountUses: item.maximumDiscountUses,
                id: item.id,
                priority: item.priority,
                active: item?.is_active ? (
                  <>
                    <div>
                      <Label
                        variant={
                          theme.palette.mode === "light" ? "ghost" : "filled"
                        }
                        color={"success"}
                      >
                        {item?.is_active ? "Available" : item?.is_active}
                      </Label>
                    </div>
                  </>
                ) : (
                  <Label
                    variant={
                      theme.palette.mode === "light" ? "ghost" : "filled"
                    }
                    color={"error"}
                  >
                    {!item?.is_active ? "Unavailable" : item?.is_active}
                  </Label>
                ),
              }
            })}
            options={{
              paging: true,
              pageSize: 10,
              emptyRowsWhenPaging: false, //to make page size fix in case of less data rows
              pageSizeOptions: [10, 20, 30],
              sorting: true,
              selection: CheckPermission(RESOURCE.COUPONS, ACTION.DELETE) ? true : false,
              actionsColumnIndex: -1,
              searchFieldAlignment: "left",
              searchFieldStyle: { color: theme.palette.grey[500] },
              headerStyle: {
                color: theme.palette.grey[600],
                backgroundColor: theme.palette.grey[200],
              },
              // rowStyle: (rowData, index) => {
              //   if (index % 2) {
              //     return { backgroundColor: "#f2f2f2" };
              //   }
              // },
            }}
            actions={
              CheckPermission(RESOURCE.COUPONS, ACTION.DELETE) ? [
                {
                  icon: () => <DeleteForever />,
                  tooltip: "Delete Rows",
                  onClick: handleDeleteRowsConformation
                }
              ] : []
            }
            localization={{
              toolbar: {
                searchPlaceholder: t("search"),
              },
              body: {
                emptyDataSourceMessage: expenseCategoryLoader ? (
                  <SkeletonLoader />
                ) : (
                  <NotFoundComponent imgUrl={noFoundImg}>
                    <p style={{ fontWeight: 600 }}>
                      {"Coupon Not found"}
                    </p>
                  </NotFoundComponent>
                ),
              },
            }}
            // other props
            components={{
              Toolbar: (props) => (
                <div className="custom-material-table-toolbar ">
                  <MTableToolbar {...props} />
                  <div style={{ padding: "0px 10px" }}>
                    <RoleBasedGuard
                      resource={RESOURCE.COUPONS}
                      action={ACTION.ADD}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        // onClick={addEditModelToggle}
                        startIcon={<AddCircleOutlineIcon />}
                        style={{ background: "", color: "#fff" }}
                        onClick={() => {
                          setAddEditDrawerShow(true);
                        }}
                      >
                        {"Add Coupon"}
                      </Button>
                    </RoleBasedGuard>
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </DeskTopContainer>
      <MobileContainer>
        <div className={classes.mobileCard}>
          <MobileTitle
            resource={RESOURCE.COUPONS}
            title={"Coupon"}
            addButton={addDrawerShow}
          />
          <SearchBarInput
            onChange={(e) => {
              setSearchCoupons(e.target.value);
            }}
            value={searchCoupons}
            placeholder={"Search"}
            clearTxt={clearTxt}
          />
          {expenseCategoryLoader ? (
            <SkeletonLoader count={3} height="10rem" />
          ) : (
            <div className={classes.mobileCategoryCard}>
              {filterCouponsList &&
                filterCouponsList.map((item, index) => (
                  <MobileCategory
                    resource={RESOURCE.COUPONS}
                    name={item.code}
                    active={item.is_active}
                    deleteData={deleteData}
                    editData={editData}
                    itemId={item?.id}
                    isMenuBar
                  />
                ))}
            </div>
          )}
        </div>
        {filterCouponsList?.length < 1 && !expenseCategoryLoader && (
          <NotFoundComponent imgUrl={noFoundImg}>
            <p style={{ fontWeight: 600 }}>
              {"No Coupon Found"}
            </p>
          </NotFoundComponent>
        )}
      </MobileContainer>
      <PopUpModel
        show={deleteModalShow}
        heading={"Coupon Delete"}
        body={"Are you sure you want to delete Coupon?"}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={() => setDeleteModalShow(false)}
            >
              {" "}
              <Cancel /> {t("popup-cancel-button-label")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => deleteFoodCategoryData(deleteCouponsId)}
            >
              {" "}
              <Delete />{" "}
              {deletingBtnProcess ? <CircularProgress /> : t("delete")}{" "}
            </Button>
          </>
        }
        onHide={() => setDeleteModalShow(false)}
      />
      <PopUpModel
        show={deletebulkPopupshow}
        heading={"Are you sure you want to delete selected Coupon?"}
        body={"Please Conform Selected Opration."}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={() => setDeletebulkPopupshow(false)}
            >
              {" "}
              <Cancel /> {t("popup-cancel-button-label")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDeleteRows}
            >
              {" "}
              <Delete /> {t("delete")}{" "}
            </Button>
          </>
        }
        onHide={() => setDeletebulkPopupshow(false)}
      />
      <TemporaryDrawer
        drawerClose={addEditDrawerClose}
        isOpen={addEditDrawerShow}
        drawerWidth="50%"
        icon={<Category />}
        title={"Coupon"}
      >
        <AddEditCoupons
          couponId={addEditCouponsId}
          drawerClose={addEditDrawerClose}
        />
      </TemporaryDrawer>
    </Root>
  );
};

export default CouponsList;
